
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A monetary amount expressed as an integer in a specified minor currency unit.`}</p>
    <p>{`This is used to avoid floating point rounding errors when expressing prices & funds.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;